import { computed, Injectable, Signal, signal } from '@angular/core';
import { NgProgressRef } from 'ngx-progressbar';

@Injectable({
  providedIn: 'root',
})
export class ProgressBarService {
  private readonly progressRef = signal<NgProgressRef | null>(null);

  readonly active: Signal<boolean> = computed(() => this.progressRef()?.active() ?? false);

  register(progressRef: NgProgressRef): void {
    this.progressRef.set(progressRef);
  }

  unregister(progressRef: NgProgressRef): void {
    if (this.progressRef() === progressRef) {
      this.progressRef.set(null);
    }
  }

  start(): void {
    this.progressRef()?.start();
  }

  complete(): void {
    this.progressRef()?.complete();
  }
}
